import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=531b7920&scoped=true&lang=html&"
import script from "./Subscription.vue?vue&type=script&lang=js&"
export * from "./Subscription.vue?vue&type=script&lang=js&"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=531b7920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b7920",
  null
  
)

export default component.exports